import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

const buttonClass = `futura-medium text-xs text-center font-bold leading-[1.125rem] tracking-[0.0625rem] text-black
                                             [text-decoration:none] uppercase
                    border border-black border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `;

// Reusable block: heading + paragraph + 4 stats + button.
const InfoSection = ({
  ariaLabel,
  heading,
  description,
  stats,
  showAsterisk = false,
  button,
  className,
}) => {
  return (
    <section
      aria-label={ariaLabel}
      className={cn(
        `m-[2.5rem_auto] max-w-[57.275rem] float-none w-[87.5%] 
        clear-both overflow-x-hidden relative
        overflow-hidden sm:pt-6
        `,
        className
      )}
    >
      <header
        className={`overflow-hidden mt-0 mb-[2.0625rem] max-w-full clear-both table 
        m-[0_auto_1.3125rem] relative text-center w-full z-[1]
        `}
      >
        <h2
          className={`scroll-mt-[5rem] text-[1.75rem] md:text-[2.25rem] mb-[1.0625rem] leading-[1.25] font-bold`}
        >
          {heading}
        </h2>
        <p className={`text-[1.25rem] leading-[1.875rem] text-left md:text-center`}>
          {description}
        </p>
      </header>

      <div
        className={`grid grid-cols-[repeat(auto-fit,169px)] justify-center`}
        style={{
          columnGap: "21px",
          gridRowGap: "21px",
        }}
      >
        {stats.map((item, itmIdx) => (
          <div key={item.id} className={`max-w-[169px] h-auto`}>
            <div
              className={`border-b border-b-black flex flex-col items-center justify-center`}
            >
              <span className={`text-[36px] leading-[45px] text-primary-red font-bold`}>{item.value}</span>
            </div>
            <div
              className={`font-bold mt-[0.5rem] text-[1.125rem] font-medium leading-[1.75rem] text-center flex items-start justify-center`}
            >
              <p
                className={`text-base leading-[20px] m-[0_0_17px]`}
              >
                {item.desc} {showAsterisk && itmIdx != stats.length - 1 ? '*' : ''}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className={cn(`mt-8 flex items-center justify-center`)}>
        <Link
          href={button.href}
          {...(button.external
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {})}
          className={buttonClass}
        >
          {button.label}
        </Link>
      </div>
    </section>
  );
};

const collegeStats = [
  { id: "alumni-network", value: "800+", desc: "Active Alumni" },
  { id: "students", value: "2500+", desc: "Active Students" },
  { id: "placement-rate", value: "96.2%", desc: "Placement Rate" },
  { id: "years-of-experience", value: "10+", desc: "Years of Experience" },
];

const AboutUs = () => {
  return (
    <>
      <InfoSection
        ariaLabel="About us"
        heading="About PCPS College"
        description="PCPS College offers internationally recognised UK undergraduate programmes in Software Engineering, Business Management, Business Analytics, and Digital Marketing. We provide globally accredited degrees in partnership with the University of Bedfordshire and are the only institution in Nepal to offer an on-campus UK degree partnership."
        stats={collegeStats}
        showAsterisk
        button={{
          label: "Learn More",
          href: "https://apply.patancollege.edu.np/",
          external: true,
        }}
      />
    </>
  );
};

export default AboutUs;